<template>
  <div>
    <loading
      v-if="loading"
      message="Загружаем информацию..."/>
    <loading
      v-else-if="saving"
      message="Сохраняем информацию..."/>
    <div
      v-else
      class="row">
      <div class="col-12 col-sm-12 col-md-10 col-lg-8">
        <admin-card>
          <admin-form-input
            v-model="newDataItem.name"
            :label-text="'Название'"
            :label-id="'inputName'"
            :input-require="true"
            :error="$v.newDataItem.name.$error"
            :error-text="'Название обязательно должно быть указано, минимум 2 символа'"
            @input="$v.newDataItem.name.$touch()"/>
          <admin-form-input
            v-model="newDataItem.code"
            :label-text="'Код'"
            :label-id="'inputCode'"
            :input-require="true"
            :error="$v.newDataItem.code.$error"
            :error-text="'Код обязательно должн быть указан, минимум 2 символа'"
            @input="$v.newDataItem.code.$touch()"/>
          <admin-form-input
            v-model="newDataItem.class"
            :label-text="'Класс'"
            :label-id="'inputClass'"
            :input-require="true"
            :error="$v.newDataItem.class.$error"
            :error-text="'Класс обязательно должн быть указан, минимум 2 символа'"
            @input="$v.newDataItem.class.$touch()"/>
          <admin-form-input
            v-model="newDataItem.sort"
            :label-text="'Сортировка статуса'"
            :label-id="'inputSort'"
            :input-require="true"
            :error="$v.newDataItem.sort.$error"
            :error-text="'Допустимо только число'"
            @input="$v.newDataItem.sort.$touch()"/>
          <admin-form-check-box
            v-model="newDataItem.enabled"
            :label-text="'Активен'"
          />
          <admin-form-multi-select
            v-model="newDataItem.amoStatuses"
            :options="amoStatuses"
            :label-text="'Id соответсвующих статутсов в Amo Crm'"
            label="name"
            trackBy="name"
            :multiple="true"
          />
          <template slot="footer">
            <button
              v-if="!loading"
              type="button"
              class="btn btn-success"
              @click.prevent="beforeUpdateForm">
              <template v-if="newDataItem.id">Сохранить изменения</template>
              <template v-else>Добавить статус</template>
            </button>
          </template>
        </admin-card>
      </div>
    </div>
  </div>
</template>

<script>
  import AdminCard from '../Components/AdminCard'
  import { required, minLength, numeric } from 'vuelidate/lib/validators'
  import AdminFormInput from './../Components/AdminFormComponents/AdminFormInput'
  import { mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import getStatusByIdQuery from 'gql/queries/getStatusById.graphql'
  import AdminFormMultiSelect
    from '../Components/AdminFormComponents/AdminFormMultiSelect'
  import AdminFormCheckBox
    from '../Components/AdminFormComponents/AdminFormCheckBox'
  import AddStatusMutation from 'gql/mutations/AddStatus.graphql'
  import UpdateStatusMutation from 'gql/mutations/UpdateStatus.graphql'
  import getAmoStatusesQuery from 'gql/queries/getAmoStatuses.graphql'

  export default {
    name: 'StatusEdit',
    components: {
      AdminFormCheckBox,
      AdminFormMultiSelect,
      AdminCard,
      AdminFormInput
    },
    watch: {
      'item.statuses' () {
        this.newDataItem = Object.assign({}, this.item.statuses[0])
      }
    },
    data () {
      return {
        loading: false,
        saving: false,
        newDataItem: {
          id: null,
          name: null,
          code: null,
          class: null,
          sort: 100,
          amoStatuses: [],
          enabled: false
        },
        amoStatuses: []
      }
    },
    validations: {
      newDataItem: {
        name: {
          required,
          minLength: minLength(2)
        },
        code: {
          required,
          minLength: minLength(2)
        },
        class: {
          required,
          minLength: minLength(2)
        },
        sort: {
          required,
          numeric
        }
      }
    },
    methods: {
      beforeUpdateForm () {
        this.$v.newDataItem.$touch()
        if (this.$v.newDataItem.$error) {
          return
        }
        if (this.$route.params.id) {
          this.updateItem()
        } else {
          this.addItem()
        }
      },
      addItem () {
        this.saving = true
        this.$apollo.mutate({
          mutation: AddStatusMutation,
          variables: this.newDataItem
        }).then((result) => {
          this.saving = false
          this.addToast({
            text: 'Статус успешно добавлен',
            type: 'success',
            dismissAfter: 3000
          })
          this.$router.push({ name: 'StatusEdit', params: { id: result.data.addStatus.id } })
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Прооизошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.saving = false
        })
      },
      updateItem () {
        this.saving = true
        this.$apollo.mutate({
          mutation: UpdateStatusMutation,
          variables: this.newDataItem
        }).then((result) => {
          this.saving = false
          this.addToast({
            text: 'Статус успешно обновлен',
            type: 'success',
            dismissAfter: 3000
          })
        }).catch((error) => {
          console.log(error)
          this.addToast({
            text: 'Прооизошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.saving = false
        })
      },
      clearData () {
        this.newDataItem = {
          id: null,
          name: null,
          class: null,
          sort: 100,
          code: null,
          amoStatuses: []
        }
        this.$v.newDataItem.$reset()
      },
      loadData () {
        this.$apollo.queries.item.skip = false
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    apollo: {
      item: {
        skip: true,
        query: getStatusByIdQuery,
        variables () {
          return {
            id: this.$route.params.id
          }
        },
        fetchPolicy: 'network-only',
        watchLoading (isLoading, countModifier) {
          this.loading = isLoading
        },
        update: (data) => {
          return data
        }
      },
      amoStatuses: {
        query: getAmoStatusesQuery,
        fetchPolicy: 'network-only',
        watchLoading (isLoading, countModifier) {
          this.loading = isLoading
        },
        update: (data) => {
          return data.amoStatuses
        }
      }
    },
    created () {
      if (this.$route.params.id) {
        this.loadData()
      } else {
        this.clearData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// StatusEdit.vue?63a2f9b6